var map = {
	"./soil.svg": 922,
	"./tree-step-1.svg": 378,
	"./tree-step-2_1.svg": 379,
	"./tree-step-2_2.svg": 380,
	"./tree-step-3_1.svg": 381,
	"./tree-step-3_2.svg": 382,
	"./tree-step-3_3.svg": 383,
	"./tree-step-4_1.svg": 384,
	"./tree-step-4_2.svg": 385,
	"./tree-step-4_3.svg": 386,
	"./tree-step-4_4.svg": 387,
	"./tree-step-5_1.svg": 388,
	"./tree-step-5_2.svg": 389,
	"./tree-step-5_3.svg": 390,
	"./tree-step-5_4.svg": 391,
	"./tree-step-5_5.svg": 392,
	"./tree-step-6_1.svg": 393,
	"./tree-step-6_2.svg": 394,
	"./tree-step-6_3.svg": 395,
	"./tree-step-6_4.svg": 239,
	"./tree-step-6_5.svg": 396,
	"./tree-step-6_6.svg": 397,
	"./tree-step.svg": 398,
	"./tree-step_soil.svg": 135,
	"./tree_1.svg": 923,
	"./tree_2.svg": 924,
	"./tree_3.svg": 925,
	"./tree_4.svg": 926,
	"./tree_5.svg": 927,
	"./tree_6.svg": 928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 156;